export default "__VITE_ASSET__BEH5VXZA__"